import { render, staticRenderFns } from "./word-directory.vue?vue&type=template&id=d084cd1c&scoped=true&"
import script from "./word-directory.vue?vue&type=script&lang=js&"
export * from "./word-directory.vue?vue&type=script&lang=js&"
import style0 from "./word-directory.vue?vue&type=style&index=0&id=d084cd1c&lang=scss&scoped=true&"
import style1 from "./word-directory.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d084cd1c",
  null
  
)

export default component.exports